export var i18n = {
    invalidPostcodeMessage: 'Enter a valid postcode',
    postcodeLookupLabel: 'Postcode',
    postcodeLookupButton: 'Find address',
    findAddressCancelledButton: 'Cancel',
    changePostcodeButton: 'Change',
    changePostcodeAriaLabel: 'Change postcode',
    selectAddressLabel: 'Select an address',
    selectAddressPlaceholder: 'Select an address from the list',
    selectAddressButton: 'Select address',
    selectAddressRequiredMessage: 'Select an address to continue',
    noAddressesFoundMessage: 'No matching addresses were found',
    addressLine1Label: 'Address line 1',
    addressLine1RequiredMessage: 'You must complete this field',
    addressLine2Label: 'Address line 2',
    addressLine3Label: 'Address line 3',
    townLabel: 'Post town',
    countyLabel: 'County',
    postcodeLabel: 'Postcode',
    countryLabel: 'Country',
    changeAddressButton: 'I need to change the address',
    saveAndClose: 'Save and close',
};
//# sourceMappingURL=i18nAddressLookup.js.map